import React, {useEffect, useState} from 'react';
import {Router, useNavigate, useParams} from '@reach/router';

import {requestRecovery, handleRecovery, updateUser} from '../services/auth';
import Layout from '../components/layout';
import Form from '../components/form';
import Input from '../components/input';

import styles from './styles/recover.module.scss';

const RecoverPage = () => {
  const [errorMessage, setErrorMessage] = useState('');
  const [processing, setProcessing] = useState(false);
  const [recoverySent, setRecoverySent] = useState(false);

  const requestPasswordReset = (event: any) => {
    event.preventDefault();

    const form = event.target;
    const {email} = form.elements;

    setErrorMessage('');
    setProcessing(true);

    requestRecovery(email.value)
      .then(() => {
        setProcessing(false);
        setRecoverySent(true);
      })
      .catch((error: any) => {
        setProcessing(false);
        if (error.status === 404) {
          // Fake success to make it slightly harder to check for existing accounts
          setRecoverySent(true);
        } else {
          setErrorMessage(error.message);
        }
      });
  };

  return (
    <Layout title="Reset password">
      <Form
        name="ResetPassword"
        submitButtonLabel="Reset password"
        errorMessage={errorMessage}
        isProcessing={processing}
        onSubmit={requestPasswordReset}
      >
        <Input
          isRequired
          isFocused
          isDisabled={processing}
          type="text"
          name="email"
          label="Email"
        />
      </Form>
      {recoverySent && (
        <div className={styles.confirmation}>
          <div>
            <p>Check your email for the next step!</p>
            <p>(You can close this page.)</p>
            <p>(But only if you want to, no pressure.)</p>
          </div>
        </div>
      )}
    </Layout>
  );
};

const SetPasswordPage = () => {
  const [errorMessage, setErrorMessage] = useState('');
  const [message, setMessage] = useState('');
  const [processing, setProcessing] = useState(true);
  const {recover} = useParams();

  const navigate = useNavigate();

  useEffect(() => {
    if (recover) {
      setProcessing(true);
      handleRecovery(recover)
        .then(() => {
          setProcessing(false);
          setMessage(
            'Your password reset request was successful. Please set a new password to proceed.'
          );
        })
        .catch((error: any) => {
          setProcessing(false);
          if (error.status === 404) {
            setErrorMessage(
              'Sorry, it looks like your reset request has expired. Please click the "Forgot your password?" link on the Login page to request a new one.'
            );
          } else {
            setErrorMessage(error.message);
          }
        });
    }
  }, [recover]);

  const updatePassword = (event: any) => {
    event.preventDefault();

    // @ts-expect-error ts-migrate(2554) FIXME: Expected 1 arguments, but got 0.
    setErrorMessage();
    setProcessing(true);

    const form = event.target;
    const {password} = form.elements;

    if (password.value) {
      void updateUser({password: password.value}).then((response: any) => {
        setProcessing(false);
        if (response.json?.code) {
          setErrorMessage(response.json.msg);
        } else {
          setMessage(
            'Your password has been updated. You can now log in using your new password.'
          );
          void navigate('/tools/');
        }
      });
    } else {
      setProcessing(false);
      setErrorMessage('Please enter a new password');
    }
  };

  return (
    <Layout title="Set a new password">
      <Form
        name="NewPassword"
        errorMessage={errorMessage}
        message={message}
        submitButtonLabel="Set password"
        isProcessing={processing}
        onSubmit={updatePassword}
      >
        <Input
          isRequired
          isFocused
          isDisabled={processing}
          type="password"
          name="password"
          label="Password"
        />
      </Form>
    </Layout>
  );
};

const Recover = () => {
  if (typeof window === 'undefined') return null;
  return (
    <Router basepath="/recover">
      {/* @ts-expect-error ts-migrate(2322) FIXME: Type '{ path: string; }' is not assignable to type... Remove this comment to see the full error message */}
      <RecoverPage path="/" />
      {/* @ts-expect-error ts-migrate(2322) FIXME: Type '{ path: string; }' is not assignable to type... Remove this comment to see the full error message */}
      <SetPasswordPage path="/:recover" />
    </Router>
  );
};

export default Recover;
